export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13509.c39384f2.jpg";